import styles from '../TargetGroupTable.module.css';
import React from 'react';
import {
    AnalysisAPI,
    ReportAPI,
} from '../../../../typings/participant_activity';

interface CandidateReportStatusProps {
    report?: ReportAPI;
    analysis?: AnalysisAPI;
    hasErrorStatus: boolean;
}

const CandidateReportStatus: React.FunctionComponent<
    CandidateReportStatusProps
> = (props) => {
    const { report, analysis, hasErrorStatus } = props;

    return (
        <>
            {!!report && analysis?.status !== 'pending' && (
                <span
                    className={styles.status_wrapper}
                    style={{
                        backgroundColor: '#1AA277',
                    }}>
                    Completed
                </span>
            )}

            {!!report && analysis?.status === 'pending' && (
                <span
                    className={styles.status_wrapper}
                    style={{
                        backgroundColor: '#1AA277',
                    }}>
                    Partially completed
                </span>
            )}

            {!report && analysis?.status === 'pending' && !hasErrorStatus && (
                <span
                    className={styles.status_wrapper}
                    style={{
                        backgroundColor: 'rgba(95, 145, 204, 1)',
                    }}>
                    Analysing
                </span>
            )}

            {!report && analysis?.status === 'pending' && hasErrorStatus && (
                <span
                    className={styles.status_wrapper}
                    style={{
                        backgroundColor: '#F6510E',
                    }}>
                    Failed
                </span>
            )}

            {!report && !analysis && (
                <span
                    className={styles.status_wrapper}
                    style={{
                        backgroundColor: '#BBC9D8',
                    }}>
                    Not started
                </span>
            )}
        </>
    );
};

export default CandidateReportStatus;
